import React from 'react';
import './LeadsGrowBanner.css';
import { useNavigate } from 'react-router-dom';
import { AccessTypeConstants } from '@/_constant';
import { accessTypeName, selectedAccessType } from '@/utility';
import { useLanguageContext } from '@/hooks';

const LeadsGrowBanner = ({ selectCategory }) => {
  const navigate = useNavigate();
  const { language } = useLanguageContext();

  const accessDisplayCode = selectCategory?.access_display_code;
  const rawAccessName = (selectCategory?.access_name || '').toLowerCase();
  const resolvedAccessName = accessTypeName(selectCategory?.access_name);
  const activeAccessType = selectedAccessType() || (accessDisplayCode ? accessTypeName(language(accessDisplayCode)) : '');

  const isDealer =
    accessDisplayCode === 'access.dealer' ||
    rawAccessName === 'dealer' ||
    resolvedAccessName === 'dealer' ||
    activeAccessType === AccessTypeConstants.DEALER ||
    activeAccessType === 'dealer';

  const isServiceProvider =
    accessDisplayCode === 'access.service_provider' ||
    rawAccessName === 'service provider' ||
    rawAccessName === 'service-provider' ||
    resolvedAccessName === 'service-provider' ||
    activeAccessType === AccessTypeConstants.SERVICE_PROVIDER ||
    activeAccessType === 'service_provider' ||
    activeAccessType === 'service-provider';

  if (!isDealer && !isServiceProvider) {
    return null;
  }

  return (
    <div className="container py-3">

      <img
        src="/home-banner/leads-grow/leads.png"
        alt="Check more leads & grow your business"
        className="leads-grow-banner-img"
        onClick={() => navigate('/purchase-request/buy-leads')}
      />
    </div>
  );
};

export default LeadsGrowBanner;

